import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormInputTextAreaComponent } from './form-input-text-area.component';
import { TextareaModule } from 'primeng/textarea';
import { FormInputErrorModule } from '../form-input-error/form-input-error.module';
import { SharedModule } from '../../../modules/shared/shared.module';

@NgModule({
  declarations: [
    FormInputTextAreaComponent
  ],
  imports: [
    CommonModule,
    TextareaModule,
    FormInputErrorModule,
    SharedModule,
  ],
  exports: [
    FormInputTextAreaComponent
  ]
})
export class FormInputTextAreaModule { }
